import moment from 'moment-timezone';
import {
  LIVE_EXPERIENCE_CALENDAR_CASE_TABS,
  LIVE_EXPERIENCE_HUB_CASE_TABS,
  LIVE_EXPERIENCE_NOT_SHOW_SETTING_CASE_TABS,
  LIVE_EXPERIENCE_SHOW_SETTING_CASE_TABS,
  PRE_REORDERED_NOT_SHOW_SETTING_CASE_TABS,
  PRE_REORDERED_SHOW_SETTING_CASE_TABS,
  SIDEBAR_REELS_REORDERED
} from "../config/sidebar";
import {Credentials, Signer} from '@aws-amplify/core';
import Config from "../config/config";
import {YOUTUBE_DATA} from "../config/mock";
import {useEffect, useState} from "react";
import {TIMEZONES} from '../config/timezones';
import _ from "underscore";

const SERVICE_NAME = Config.MQTT_SERVICE_NAME;
class UtilService {

  static storeData = null;

  static checkTrialAccess = (data: any, role_access: string) => {
    if (data && data.role_access && data.role_access.length > 0) {
      const trial_access = data.role_access.filter((val: any) => val.access_name === role_access);
      return !!(trial_access.length > 0 && trial_access[0].access_value);
    }
    return false;
  };

  static mqttEndpoint = async () => {
    return (async () => {
      const endpoint = "wss://" + Config.MQTT_SERVICE_URL + "/mqtt";
      const serviceInfo = {
        service: SERVICE_NAME,
        region: "us-east-1",
      };
      const { accessKeyId: access_key, secretAccessKey: secret_key, sessionToken: session_token } = await Credentials.get();

      return Signer.signUrl(endpoint, { access_key, secret_key, session_token }, serviceInfo);
    })();
  };

  static getTimeNumberFromString(time: string) {
    if (!time) return 0;
    if (time.length > 10) {
      return Number(time.slice(0, 10))
    } else {
      return Number(time);
    }
  }

  static getDateTime(date: Date) {
    const d = new Date(date);
    const timezone = UtilService.storeData;
    if (timezone) return moment.tz(d, timezone).format();
    else return moment(d).format();
  }

  static getDateTimeFilter(date: string) {
    const d = new Date(date);
    const timezone = UtilService.storeData;
    if (timezone) return moment.tz(d, timezone).format('MM/DD/YY HH:MM A') + ':00+00';
    else return moment(d).format('MM/DD/YY HH:MM A') + ':00+00';
  }

  static getLocalDateTime(date: string) {
    if (!date) {
      return "-"
    }
    const d = new Date(date);
    const timezone = UtilService.storeData;
    if (timezone) return moment.tz(d, timezone).format('MM/DD/YY HH:MM A');
    else return moment(d).format('MM/DD/YY HH:MM A');
  }

  static getLocalDateTimeZone(date: string) {
    if (!date) {
      return "-"
    }
    const d = new Date(date);
    const timezone = UtilService.storeData;
    if (timezone) return moment.tz(d, timezone).format('MMM DD, YYYY hh:mm A zz');
    else return moment(d).format('MMM DD, YYYY hh:mm A');
  }

  static getExperienceLengthFormatString(date: string) {
    if (!date) {
      return "-"
    }
    const d = new Date(parseInt(date));
    const timezone = UtilService.storeData;
    if (timezone) return moment.tz(d, timezone).format('MM/DD/YY');
    else return moment(d).format('MM/DD/YY');
  }

  static getParticipantDateFormatString(date: string) {
    if (!date) {
      return "-"
    }
    const d = new Date(date);
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const myTimezone = TIMEZONES.find((item: any) => item.group.includes(timezone ? timezone : moment.tz.guess()));
    if (timezone) {
      return moment.tz(d, timezone).format('MM/DD/YY h:mm A') + " " + myTimezone?.abbreviation;
    } else {
      return moment(d).format('MM/DD/YY h:mm A ') + " " + myTimezone?.abbreviation;
    }
  }

  static getParticipantDate(d: Date) {
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const myTimezone = TIMEZONES.find((item: any) => item.group.includes(timezone ? timezone : moment.tz.guess()));
    if (timezone) {
      return moment.tz(d, timezone).format('MM/DD/YY h:mm A') + " " + myTimezone?.abbreviation;
    } else {
      return moment(d).format('MM/DD/YY h:mm A ') + " " + myTimezone?.abbreviation;
    }
  }

  static getReelThumbnailDateFormatString(date: string) {
    if (!date) {
      return "-"
    }
    const d = new Date(date);
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) {
      return moment.tz(d, timezone).format('MMM DD');
    } else {
      const myTimezone = TIMEZONES.find((item: any) => item.group.includes(moment.tz.guess()));
      return moment(d).format('MMM DD') + myTimezone?.abbreviation;
    }
  }

  static getPhoneSensor(data: any, type: string) {
    if (!data) {
      return "-"
    }
    if (type === "phone") {
      if (data.phone) {
        return data.phone
      }
    } else if (type === "sensor") {
      if (data.sensor) {
        return data.sensor
      }
    }
  }

  static getOverviewExperienceDateFormatString(milliseconds: string) {
    if (!milliseconds) {
      return '-';
    }
    const d = new Date(Number(milliseconds) * 1000);
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const myTimezone = TIMEZONES.find((item: any) => item.group.includes(timezone ? timezone : moment.tz.guess()));
    if (timezone) {
      return moment.tz(d, timezone).format('MMM DD hh:mm A') + " " + myTimezone?.abbreviation;
    } else {
      return moment(d).format('MMM DD hh:mm A ') + " " + myTimezone?.abbreviation;
    }
  }

  static getTimeZone(milliseconds: string) {
    if (!milliseconds) {
      return '-';
    }
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const myTimezone = TIMEZONES.find((item: any) => item.group.includes(timezone ? timezone : moment.tz.guess()));
    return myTimezone?.abbreviation;
  }

  static getTimeZoneDate(dateTime: any) {
    if (!dateTime) {
      return '-';
    }
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const myTimezone = TIMEZONES.find((item: any) => item.group.includes(timezone ? timezone : moment.tz.guess()));
    return myTimezone?.abbreviation;
  }

  static getExpDateFormatString(milliseconds: string) {
    if (!milliseconds) {
      return '-';
    }
    const d = new Date(Number(milliseconds) * 1000);
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const myTimezone = TIMEZONES.find((item: any) => item.group.includes(timezone ? timezone : moment.tz.guess()));

    if (timezone) {
      return moment.tz(d, timezone).format('MMM DD h:mm A') + " " + myTimezone?.abbreviation;
    } else {
      return moment(d).format('MMM DD h:mm A ') + " " + myTimezone?.abbreviation;
    }
  }


  static getOverviewExperienceStartDate(milliseconds: string) {
    if (!milliseconds) {
      return '-';
    }
    const d = new Date(Number(milliseconds) * 1000);
    const timezone = UtilService.storeData || Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) {
      return moment.tz(d, timezone).format('MMM DD');
    } else {
      return moment(d).format('MMM DD');
    }
  }

  static getParticipantListDate(dateTime: string) {
    const options: any = { year: "numeric", month: 'long', day: 'numeric' };
    const converted = new Date(dateTime);
    return converted.toLocaleDateString("en-US", options);
  }

  static getParsedTags(tags: any) {
    const result = [];
    for (const i in tags) {
      tags[i].tag_name && result.push(tags[i].tag_name)
    }
    if (result.length) return result.join(', ');
    return '-'
  }
  static getParsedTowerTags(tags: any) {
    const result = [];
    for (const i in tags) result.push(i + ':' + tags[i]);
    if (result.length) return result.join(', ');
    return '-'
  }

  static getParsedTagsForSort(tags: any) {
    const result = [];
    for (const i in tags) result.push(tags[i].tag_name ? tags[i].tag_name.toLowerCase() : '');
    if (result.length) return result.join(', ');
    return '-'
  }

  static getParsedTagArray(tags: any) {
    const result = [];
    for (const i in tags) result.push(tags[i].tag_name);
    return result;
  }

  static generateCsvFileName(exp: any) {
    const { session } = exp;
    const { session_title } = session;

    const d = new Date();
    const timezone = UtilService.storeData;
    let dateStr = '';
    if (timezone) dateStr = moment.tz(d, timezone).format('MM_DD_YY');
    else dateStr = moment(d).format('MM_DD_YY');
    const expTitle = session_title.replace(' ', '_');
    return `${expTitle}_${dateStr}`;
  }

  static getOnlineColor(status: string) {
    let color = 'green';
    if (status === 'away') { color = 'grey' }
    if (status === 'offline') { color = 'red' }
    return color;
  }

  static getStatusColor(status: string) {
    let color = 'blue';
    if (status === 'LIVE') { color = '#2ac940' }
    if (status === 'PAUSED') { color = 'orange' }
    if (status === 'STOPPED') { color = 'yellow' }
    if (status === 'ENDED') { color = 'brown' }
    if (status === 'COMPLETED') { color = 'green' }
    if (status === 'CANCELLED') { color = 'red' }

    return color;
  }


  static padWithZero(number: number) {
    const string = number.toString();
    if (number < 10) {
      return "0" + string;
    }
    return string;
  }

  static padWithZero2(number: number) {
    const string = number.toString();
    if (number < 10) {
      return "00" + string;
    }
    if (number < 100) {
      return "0" + string;
    }
    return string;
  }

  static timerDay(seconds: number) {
    const result = Math.floor(seconds / 86400);
    return result
  }

  static getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  static getChartColor(config: string) {
    let color = '#c2185b';
    if (config === 'heart') { color = '#2196f3' }
    if (config === 'score') { color = '#f9a825' }

    return color
  }

  static getSeries(data: any, filters: any, attenders: any) {
    if (filters.config === 'heart') {
      return data.filter((u: any, index: number) => (filters.category === 'single' && attenders.findIndex((p: any) => p.id === u.id) !== -1) || (filters.category === 'all' && index === 0)).map((item: any) => ({ name: item?.name, data: item?.hearts }))

    }
    if (filters.config === 'score') {
      return data.filter((u: any, index: number) => (filters.category === 'single' && attenders.findIndex((p: any) => p.id === u.id) !== -1) || (filters.category === 'all' && index === 0)).map((item: any) => ({ name: item?.name, data: item?.scores }))

    }
    if (filters.config === 'safety') {
      return data.filter((u: any, index: number) => (filters.category === 'single' && attenders.findIndex((p: any) => p.id === u.id) !== -1) || (filters.category === 'all' && index === 0)).map((item: any) => ({ name: item?.name, data: item?.safety }))

    } else {
      return []
    }
  }

  static getSeri(data: any, filters: any, item: any) {
    if (filters.config === 'heart') {
      return data.find(((x: any) => x.id === item.id))?.hearts
    }
    if (filters.config === 'score') {
      return data.find(((x: any) => x.id === item.id))?.scores
    }
    if (filters.config === 'safety') {
      return data.find(((x: any) => x.id === item.id))?.safety
    }
  }

  static getTitle(pathname: string) {
    let title = '';

    if (pathname.includes('dashboard')) { title = 'Dashboard' }
    if (pathname.includes('test')) { title = 'Test Page' }
    if (pathname.includes('profile')) { title = 'Profile' }
    if (pathname.includes('onboarding')) { title = 'Creator Onboarding' }
    if (pathname.includes('experience-builder')) { title = 'Creator Experience Builder' }
    if (pathname.includes('creator/dashboard')) { title = 'My Experiences' }
    if (pathname.includes('experience-manager')) { title = localStorage.getItem("session_name") || ""; }
    if (pathname.includes('admin/role')) { title = 'Admin Roles' }
    if (pathname.includes('user/notification')) { title = 'Notification' }
    if (pathname.includes('/participant/lists')) { title = 'My Participant Lists' }
    if (pathname.includes('/participant/list') && pathname.includes('/detail')) {
      return localStorage.getItem('listName') ? localStorage.getItem('listName') : '';
    }
    //admin users
    if (pathname.includes('admin/user')) { title = 'Admin' }
    if (pathname.includes('subscriber/admin/user')) { title = 'Admin' }
    if (pathname.includes('admin/billing')) { title = 'Admin' }
    if (pathname.includes('subscriber/admin/billing')) { title = 'Admin' }

    return title
  }

  static checkPick(picks: any, child: any, index: number) {
    if (child.title === 'Other') {
      const pick = index === 0 ? picks.find((item: any) => item.name === 'PREOTHER') : picks.find((item: any) => item.name === 'LIVEOTHER');
      return pick?.value['selected']
    } else {
      const pick = picks.find((item: any) => item.name === child.name);
      return pick?.value
    }
  }

  static getLastStep(preferences: any) {
    let step = 1;
    if (preferences.title.id) { step = 2; }
    if (preferences.prerecord.id) { step = 3; }
    if ((preferences.entertainment && preferences.entertainment.value)
      || (preferences.advertising && preferences.advertising.value)
      || (preferences.education && preferences.education.value)
      || (preferences.performance && preferences.performance.value)
      || (preferences.corporate && preferences.corporate.value)
      || (preferences.training && preferences.training.value)
      || (preferences.meetings && preferences.meetings.value)
      || (preferences.events && preferences.events.value)
      || (preferences.shopping && preferences.shopping.value)
      || (preferences.tours && preferences.tours.value)) {
      step = 4;
    }
    if ((preferences.somethingelse && preferences.somethingelse.value)
      || (preferences.learnparticipants && preferences.learnparticipants.value)
      || (preferences.identifyimprove && preferences.identifyimprove.value)
      || (preferences.comparecontent && preferences.comparecontent.value)) {
      step = 4;
    }
    if ((preferences.dataexperience && preferences.dataexperience.id)) { step = 5; }
    if (preferences.cretoronboarding && preferences.cretoronboarding.id) { step = 6; }
    return step
  }

  static capitalizeFirstLetter = (str: any) => {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return ""
  }

  static getTitlePickcategory = (children: any, str: any) => {
    return children.find((item: any) => item.name === str);
  }

  static builderSidebar = (userMetrics: any, key: string) => {


    let result = userMetrics[key] ? true : false;
    if (key === 'moderatedCalendarInviteStep') {
      result = userMetrics[key] === 4 ? true : false;
    }
    if (key === 'path') {
      result = userMetrics[key] === 0 ? false : true;
    }
    if (key === 'asyncExperienceName') {
      result = !userMetrics.sessionCode ? false : true;
    }
    if (key === 'moderatedAgendaSchedules') {
      result = userMetrics[key] && userMetrics[key].length && userMetrics[key].length > 0 ? true : false;
    }
    if (key === 'asyncParticipants') {
      result = userMetrics[key] && userMetrics[key].length && userMetrics[key].length > 0 ? true : false;
    }
    return result;
  }

  static detectSidebarConfig = (useMetrics: any, saveSetting: boolean) => {

    const { path, moderatedInviteWay } = useMetrics;

    if (path === 2) { // for live experience
      if (moderatedInviteWay === 'link') {
        return !saveSetting ? LIVE_EXPERIENCE_SHOW_SETTING_CASE_TABS : LIVE_EXPERIENCE_NOT_SHOW_SETTING_CASE_TABS;
      } else if (moderatedInviteWay === 'hub') {
        return LIVE_EXPERIENCE_HUB_CASE_TABS;
      }
      return LIVE_EXPERIENCE_CALENDAR_CASE_TABS
    }
    return !saveSetting ? PRE_REORDERED_SHOW_SETTING_CASE_TABS : PRE_REORDERED_NOT_SHOW_SETTING_CASE_TABS;
  };


  static detectSidebarReelsConfig = () => {

    // const { path, moderatedInviteWay } = useMetrics;

    return SIDEBAR_REELS_REORDERED;
  };

  static getStartDateTime = () => {
    const now = new Date();
    const mod = now.getMinutes() % 15;
    const addTime = (mod === 0) ? 15 : (15 - mod);
    return new Date(now.getTime() + addTime * 60 * 1000);
  }

  static getEndDateTime = (startDateTime: Date) => {
    return new Date(Math.ceil(startDateTime.getTime() + 60 * 60 * 1000));
  }


  static getEndDateMobileTime = (startDateTime: Date) => {
    return new Date(Math.ceil(startDateTime.getTime() + 4 * 60 * 60 * 1000));
  }

  static getRoundedUpDateTime = (datetime: Date) => {
    const diff = 1000 * 60 * 60;
    return new Date(Math.ceil(datetime.getTime() / diff) * diff);
  }

  static getXHoursAboveDateTime = (datetime: Date, x: number) => {
    return new Date(datetime.getTime() + (x * 60 * 60 * 1000))
  };


  static getAsyncAddminuite = () => {
    const now = moment();
    return moment(now).add(1, "minutes").toDate();
  }

  static getDateAddseconds = (date: any, seconds: number) => {
    return moment(date).add(seconds, "seconds").toDate();
  }

  static getXMinsBehindTime = (time: number, x: number) => {
    return time - (x * 60 * 1000)
  };

  // creator experience builder last active step for progressbar
  static getLastActiveStep(userMetrics: any) {

    const {
      path,
      item,
      moderatedInviteWay,
      moderatedName,
      moderatedCalendarInviteStep,
      asyncParticipants,
      moderatedCompleted,
      asyncExperienceName,
      asyncCompleted,
      sessionCode
    } = userMetrics;

    let step = 0;
    if (item) { step = 1; }
    if (moderatedInviteWay) { step = 2; }
    if (moderatedName || moderatedCalendarInviteStep === 4 || (asyncExperienceName && sessionCode)) { step = 4; }

    if (path === 1 && asyncParticipants.length > 0) { step = 4; }
    if (path === 2 && asyncParticipants.length > 0) { step = 5; }
    if (moderatedCompleted || asyncCompleted) { step = 6; }

    return step
  }

  static checkYoutubeVimeoURL = (url: string) => {
    if (!url) { return null }
    const cleaned = url.replace(/^(https?:)?\/\/(www\.)?/, '');
    const prefixes = [
      'youtube.com/',
      'm.youtube.com/',
      'youtu.be/',
      'vimeo.com/'
    ];
    for (const prefix of prefixes) {
      if (cleaned.startsWith(prefix)) {
        if (url.includes('youtube.com/') || url.includes('m.youtube.com/') || url.includes('youtu.be/')) {
          return 'https://www.youtube.com/oembed?url='
        }
        if (url.includes('vimeo.com/') && url.length <= 28) {
          return 'https://vimeo.com/api/oembed.json?url='
        }
        return null;
      }
    }
    return null;
  };

  static validateYouTubeUrl = (url: string) => {
    // const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|v=|\?v=)([^#]*).*/;
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : false;
    // const match = url.match(regExp);
    // return !!(match && match[2].length === 11);
  }

  static validateVimeoUrl = (url: string) => {
    const regExp = /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
    // const regExp = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
    const match = url.match(regExp);
    return !!match;
  }

  static validateSurveyLink = (url: string) => {
    const regExp = /(?:https:\/\/(?:www\.)?)[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g;
    const match = url.match(regExp);
    return !!match;
  }

  static getLocalTime = (datetime: any) => {
    const timezone = UtilService.storeData;
    if (datetime && timezone) {
      const zone: any = moment.tz.zone(timezone);
      const offset = zone.parse(datetime);
      const offset2 = new Date().getTimezoneOffset()
      return new Date(datetime.getTime() - ((offset - offset2) * 60 * 1000))
    }
    else {
      return new Date()
    }
  }
  static getLocalTimeReverse = (datetime: any) => {
    const timezone = UtilService.storeData;
    if (datetime && timezone) {
      const zone: any = moment.tz.zone(timezone);
      const offset = zone.parse(datetime);
      const offset2 = new Date().getTimezoneOffset()
      return new Date(datetime.getTime() + ((offset - offset2) * 60 * 1000))
    }
    else {
      return new Date()
    }
  }

  static getLocalEpoch = (datetime: string) => {
    const offset = new Date().getTimezoneOffset();
    return Math.floor((new Date(datetime).getTime() - (offset * 60 * 1000)) / 1000)
  }

  static getLocalEpoch2 = (datetime: string) => {
    return Math.floor((new Date(datetime.replace(' ', 'T').concat('Z')).getTime()) / 1000)
  }

  static getEpochToTime = (given_seconds: number) => {
    const dateObj = new Date(given_seconds * 1000);

    const year = dateObj.getUTCFullYear();
    const month = dateObj.getUTCMonth() + 1;
    const day = dateObj.getUTCDate();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();

    return year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0') + ' ' + hours.toString().padStart(2, '0') + ':' +
      minutes.toString().padStart(2, '0') + ':' +
      seconds.toString().padStart(2, '0');
  }

  static getNowUTCTime = () => {
    const offset = new Date().getTimezoneOffset();
    return new Date().getTime() + (offset * 60 * 1000);
  };

  static getNowLocalTime = () => {
    return Math.floor(new Date().getTime() / 1000);
  };

  static getSecondsFromHHMMSS = (time: string) => {
    const actualTime = time.split(':');
    return (+actualTime[0]) * 60 * 60 + (+actualTime[1]) * 60 + (+actualTime[2]);
  };

  static convertSecondsToHHMMSS = (given_seconds: number) => {
    const dateObj = new Date(given_seconds * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();

    return hours.toString().padStart(2, '0') + ':' +
      minutes.toString().padStart(2, '0') + ':' +
      seconds.toString().padStart(2, '0');
  };

  static getExperienceLength = (given_seconds: number) => {
    const day = Math.floor(given_seconds / 86400);
    const _given_seconds = day > 0 ? given_seconds % 86400 : given_seconds;

    const dateObj = new Date(_given_seconds * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    if (day > 0) {
      return `${day}d ${hours}h ${minutes}m ${seconds}s`
    } else {
      if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
      } else {
        if (minutes > 0) {
          return `${minutes}m ${seconds}s`;
        } else {
          return `${seconds}s`;
        }
      }
    }
  };

  static overviewHighlightsFullTime = (given_seconds: number) => {
    const dateObj = new Date(given_seconds * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    const total = hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0')
    return total
  };

  static overviewHighlightsTimeFormat = (given_seconds: number) => {
    const dateObj = new Date(given_seconds * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    } else {
      if (minutes > 0) {
        return `00:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      } else {
        return `00:00:${seconds.toString().padStart(2, '0')}`
      }
    }
  };

  static getSimpleDate(seconds: any) {
    if (!seconds) {
      return '-'
    }
    const d = new Date(Number(seconds * 1000));
    const timezone = UtilService.storeData;
    if (timezone) return moment.tz(d, timezone).format('MM/DD/YY');
    else return moment(d).format('MM/DD/YY');
  }

  static getSimpleDateTime(seconds: any) {
    //07/31/20 - 10:30PM PST
    if (!seconds) {
      return '-'
    }
    const d = new Date(Number(seconds) * 1000);

    if (d.getFullYear() < 2000) {
      return '-'
    }

    const timezone = UtilService.storeData;
    if (timezone) {
      return moment.tz(d, timezone).format('MM/DD/YY - HH:MM A z');
    } else {
      const tz = moment.tz(d, moment.tz.guess()).format('z');
      return moment(d).format('MM/DD/YY - HH:MM A ') + (tz.includes('0') ? '' : tz);
    }
  }

  static getThumbnailImg = (code: any, stimulus: any) => {

    const session = stimulus.find((item: any) => item.session_code === code)

    if (session && session.stimulus && session.stimulus[0] && session.stimulus[0].thumbnails) {
      return session.stimulus[0].thumbnails[0].url
    }

    return ''
  }

  static filterByProject = (sessions: any, projectId: number) => {
    if (projectId === -1) {
      return sessions
    }
    const filtered = sessions.filter((item: any) => item.project_folders && item.project_folders.includes(projectId))
    return filtered
  }

  static calculateTwoDays = (d1: string, d2: string) => {

    // let days = Math.floor(( Number(d2) - Number(d1) ) / 86400000);
    const hours = Math.floor((Number(d2) - Number(d1)) / 3600000);
    // let mins = Math.floor(( Number(d2) - Number(d1) ) / 60000);

    return hours + ' hours';
  }


  static calculateTrialDays = (date1: any) => {

    const date = new Date()
    const timezone = UtilService.storeData;

    if (timezone) {
      const date2 = moment(date).tz(timezone);
      date1 = moment.unix(date1).tz(timezone);

      return date2.diff(date1, 'days');
    } else {

      const date2 = moment(date);
      date1 = moment.unix(date1)

      return date2.diff(date1, 'days');
    }
  }



  static calculateNextDate = (date1: any, days: any) => {
    const timezone = UtilService.storeData;
    if (timezone) {
      const date2 = moment.unix(date1).tz(timezone).format('YYYY-MM-DD');
      const date = moment(date2).add(days, 'days').format('MMMM DD, YYYY');

      return date;
    } else {
      const date2 = moment.unix(date1).format('YYYY-MM-DD');
      const date = moment(date2).add(days, 'days').format('MMMM DD, YYYY');


      return date;
    }
  }


  static filterCompleted = (sessions: any[], status: string) => {
    return sessions.filter(item => status === "UPCOMING" ? (item.status === "LIVE" || item.status === status) : item.status === status)
  }

  static formattingString = (str: string) => {
    if (typeof (str) !== 'string' || !str) {
      return '-'
    }
    const frags = str.toLowerCase().split('_');
    for (let i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    const result = frags.join(' ');
    return result === 'Live' ? 'In Progress' : result;
  }

  static participantStatus = (str: string) => {
    if (!str) {
      return '-'
    }
    const frags = str.toLowerCase().split('_');
    for (let i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    const result = frags.join(' ');
    return (result === 'Live' || result === 'Connected') ? 'In Progress' : result;
  }

  static getUserProfile = (profile_picture: any, userProfileData: any, userPreferencesData: any) => {
    if (profile_picture) {
      return profile_picture
    }

    if (userProfileData) {
      if (userProfileData.preferences) {
        const profilePicture = userProfileData.preferences.filter((x: any) => x.preference_name === "PROFILEPIC");
        if (profilePicture.length && profilePicture[0]) {
          return profilePicture[0].preference_information
        }
      }
    }

    if (userPreferencesData) {
      const profilePicture = userPreferencesData.filter((x: any) => x.preference_name === "PROFILEPIC");
      if (profilePicture.length && profilePicture[0]) {
        return profilePicture[0].preference_information
      }
    }
    return '/static/profile.png';
  };

  static getSubHeader = (graph: number) => {
    let result = 'Immersion';
    if (graph === 1) { result = 'Safety' }
    if (graph === 2) { result = 'Immersion & Safety' }

    return result;
  }

  static getSubRealTimeHeader = (graph: number) => {
    let result = 'Overall Immersion';
    if (graph === 1) { result = 'Real-Time Immersion' }

    return result;
  }

  static refactorGraphColor = (color: string) => {
    if (!color) {
      return '#8192A2';
    }
    switch (color.toLowerCase().trim()) {
      case 'green':
        return '#1DB859';
      case 'red':
        return '#ED564A';
      case 'gray':
        return '#8192A2';
      case 'blank':
        return '#8192A2';
      default:
        return '#1DB859'
    }
  };

  static getColorFromSessionWithCategory = (item: any, category: string) => {
    let color = 'Gray';
    if (category) {
      if (category === 'immersion') {
        if ('immersion_color_indicator' in item && item.immersion_color_indicator)
          color = item.immersion_color_indicator;
      }

      if (category === 'safety') {
        if ('safety_color_indicator' in item && item.immersion_color_indicator)
          color = ((String(item.safety) === '0' || String(item.safety) === '1')) ? 'Gray' : item.safety_color_indicator;
      }
    }

    if (!color)
      color = 'Gray';

    return color.toLowerCase().trim();
  };

  static getTimeLabel = (c: number, zoom: number, start: number) => {
    let index = (c + start) * Math.pow(zoom, 2);
    if (!index) { index = 0; }
    const sec_num = Math.floor(index); // don't forget the second param
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    const seconds = sec_num - (hours * 3600) - (minutes * 60);

    const h = hours > 0 ? hours + ':' : '';
    return h + minutes + ':' + seconds.toString().padStart(2, '0');
  }

  static getTimeLabelClip = (c: number, zoom: number, start: number) => {
    const index = (c + start) * Math.pow(zoom, 2);
    const sec_num = parseInt(index.toString(), 10);
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    const seconds = sec_num - (hours * 3600) - (minutes * 60);
    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
  }

  static getStartTimeLabel = (a: number, zoom: number, start: number) => {

    let index = (a + start) * Math.pow(zoom, 2);
    if (index < 0)
      index = 0;
    if (index === 0) return '0';

    const _minutes = Math.floor(index / 60);
    const _seconds = Math.floor(index % 60);
    if (!_seconds) return `${_minutes}:00`;

    return `${_minutes}:${_seconds}`;
  }

  static getEndTimeLabel = (a: number, b: number, zoom: number, start: number) => {

    const indexA = (a + start) * Math.pow(zoom, 2);
    let indexB = (b + start) * Math.pow(zoom, 2);
    if (indexA < 0)
      indexB = (b + start - indexA) * Math.pow(zoom, 2);

    if (indexB === 0) return '0';

    const _minutes = Math.floor(indexB / 60);
    const _seconds = Math.floor(indexB % 60);
    if (!_seconds) return `${_minutes}:00`;

    return `${_minutes}:${_seconds}`
  }

  static getTimeLabel2 = (c: number, zoom: number, start: number) => {
    const time = (c + start) * Math.pow(zoom, 2);
    const index = Math.floor(time);
    if (index === 0) return '000:00';
    const _label = index % 60;

    const left = UtilService.padWithZero2(Math.floor(index / 60));
    const right = _label ? UtilService.padWithZero(_label) : '00'

    return left + ':' + right
  }

  static getTimeInputLabel = (time: string, end: boolean) => {
    if (time) {
      if (time === '00:00:00') {
        return end ? -1 : 0;
      }
      if (time.replace(' ', '').length === 8) {
        return (Number(time.split(':')[0]) * 3600 + Math.floor(Number(time.split(':')[1])) * 60 + (Number(time.split(':')[2]))) * 15;
      }
    }
    return -1
  }

  static getDragStartPoint = (positions: any, marker: any) => {

    const position = positions.find((item: any) => item.id === parseInt(marker.marker_id))
    const result = position ? position.drag : 0;

    return result
  }


  static getResizeEndPoint = (positions: any, marker: any) => {

    const position = positions.find((item: any) => item.id === parseInt(marker.marker_id))
    let result = position ? position.resize : 0;

    if (result < marker.start_marker_at - marker.end_marker_at + 2) {
      result = marker.start_marker_at - marker.end_marker_at + 2
    }

    return result
  }

  static getCurrentTimeMills = () => {
    return Math.floor(new Date().getTime());
  }

  static calcVideoEnd = (time: number) => {

    const hour = Math.floor(time / 3600);
    const minutes = Math.floor((time - 3600 * hour) / 60);
    const seconds = time % 60;

    return hour + ':' + minutes + ':' + seconds
  }

  static calcVideoEnd2 = (time: number) => {

    const hour = Math.floor(time / 3600);
    const minutes = Math.floor((time - 3600 * hour) / 60);
    const seconds = time % 60;

    return hour.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0')
  }

  static isEmpty = (str: string) => {
    return (!str || 0 === str.length);
  }

  static secondsToHms(time: any) {

    time = Math.max(0, Number(time));
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor(time % 3600 / 60);
    const seconds = Math.floor(time % 3600 % 60);

    const hDisplay = (hours < 10 ? "0" : "") + hours
    const mDisplay = (minutes < 10 ? "0" : "") + minutes
    const sDisplay = (seconds < 10 ? "0" : "") + seconds
    return hDisplay + ":" + mDisplay + ":" + sDisplay;
  }

  static convertHighlightsTime(time: any) {
    let formatTimeStr = '';
    time = Math.max(0, Number(time));
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor(time % 3600 / 60);
    const seconds = Math.floor(time % 3600 % 60);

    if (hours === 0) {
      if (minutes === 0) {
        formatTimeStr = `0:${seconds < 10 ? ('0' + seconds) : seconds}`
      } else {
        formatTimeStr = `${minutes}:${seconds < 10 ? ('0' + seconds) : seconds}`
      }
    } else {
      formatTimeStr =
        `${hours}:${minutes < 10 ? ('0' + minutes) : minutes}:${seconds < 10 ? ('0' + seconds) : seconds}`
    }
    return formatTimeStr;
  }

  static isMarkerInMoment(marker: any, moment: any) {
    if (!marker || !moment) return false;

    const startTime = Math.max(Number(marker.start_marker_at), moment.epoch_start);
    const endTime = Math.min(Number(marker.end_marker_at), moment.epoch_end);

    return (startTime <= endTime) && moment.epoch_start <= Number(marker.start_marker_at) && moment.epoch_end >= Number(marker.end_marker_at);
  }

  static isAgendaInRange(marker: any, moment: any) {
    if (!marker || !moment) return false;

    const startTime = Math.max(Number(marker.start_marker_at), moment.start);
    const endTime = Math.min(Number(marker.end_marker_at), moment.end);

    return (startTime <= endTime);
  }


  static getAgendaDateTimestamp = (started_at: number, ended_at: number, stimulus: any, cnt: number, index: number, isStart: boolean) => {
    if (stimulus) {
      // const sessionDuration = stimulus ? stimulus.stimulus_video_length : (Number(ended_at) - Number(started_at));

    }
    const sessionDuration = Number(ended_at) - Number(started_at);

    const agendaLength = sessionDuration / cnt;
    const time = Math.floor(Number(started_at) + agendaLength * (index + (isStart ? 0 : 1)));
    return time.toString();
  }

  static getBreadCrumbProjectTitle = (exp: any) => {
    if (!exp) return '-';
    const { session } = exp;
    const { projects } = session;
    if (!projects) {
      return '';
    } else {
      return projects.projectName;
    }
  };

  static getColorFromImmersion = (immersion: any) => {
    if (!immersion) return 'Gray';
    if (immersion.immersion_index >= 70) return 'Green';
    if (immersion.immersion_index >= 35) return 'Gray';
    if (immersion.immersion_index >= 2) return 'Red';
    return 'Gray';
  }

  static getColorFromImmersion2 = (immersion_index: any) => {
    if (!immersion_index) return 'gray';
    if (immersion_index >= 70) return 'green';
    if (immersion_index >= 35) return 'gray';
    if (immersion_index >= 2) return 'red';
    return 'gray';
  }

  static customHeightSafari = (all: any, graphType: any) => {
    const result = all.length * (graphType === 2 ? 2 : 1) * 600;
    return result > 1000 ? result : 1000
  }

  static isValidAudio = (fileName: string) => {
    const fileTypes = ['mp3', 'wav', 'aac', 'ogg', 'm4a'];
    const extension: any = fileName.split('.').pop();
    return fileTypes.includes(extension.toLowerCase());

  }

  static addHashTag = (history: any, pathname: string, hashtag: string) => {
    history.push(`${pathname}#${hashtag}`)
  }

  static getPredefinedExperiences = (braintrustList: any) => {
    let returnSessions = YOUTUBE_DATA
    const braintrust = braintrustList && braintrustList.length ? braintrustList.filter((obj: any) => obj.session_type === 'ASYNC') : []
    if (braintrust && braintrust.length) {
      if (braintrust.length >= 4) {
        const tempBraintrust: any = []
        braintrust.slice(0, 4).map((b: any) => {
          tempBraintrust.push({
            url: b.stimulus_link,
            title: b.session_title,
            thumbnail: (b.large_thumbnail.includes('youtube') || b.large_thumbnail.includes('ytimg'))
              ? UtilService.removeBlackBoarder(b.large_thumbnail)
              : b.large_thumbnail,
            duration: b.stimulus_video_length,
            category: b.session_category,
            subcategory: b.session_subcategory,
            streamType: b.streamType,
            stimulusType: b.stimulusType,
            sourceId: b.sourceId,
            braintrust_id: b.braintrust_id,
            session_id: b.session_id,
            customer_id: b.customer_id,
            session_code: b.session_code,
            session_started_at: b.session_started_at,
            session_ended_at: b.session_ended_at,
            customer_name: b.customer_name,
          })
        })
        return tempBraintrust.sort((a: any, b: any) => a.duration - b.duration);
      } else {
        const diffrence = 4 - braintrust.length
        const tempBraintrust = []
        for (let i = 0; i < braintrust.length; i++) {
          const obj = {
            url: braintrust[i].stimulus_link,
            title: braintrust[i].session_title,
            thumbnail: (braintrust[i].large_thumbnail.includes('youtube') || braintrust[i].large_thumbnail.includes('ytimg'))
              ? UtilService.removeBlackBoarder(braintrust[i].large_thumbnail)
              : braintrust[i].large_thumbnail,
            duration: braintrust[i].stimulus_video_length,
            category: braintrust[i].session_category,
            subcategory: braintrust[i].session_subcategory,
            streamType: braintrust[i].streamType,
            stimulusType: braintrust[i].stimulusType,
            sourceId: braintrust[i].sourceId,
            braintrust_id: braintrust[i].braintrust_id,
            session_id: braintrust[i].session_id,
            customer_id: braintrust[i].customer_id,
            session_code: braintrust[i].session_code,
            session_started_at: braintrust[i].session_started_at,
            session_ended_at: braintrust[i].session_ended_at,
            customer_name: braintrust[i].customer_name,
          }
          tempBraintrust.push(obj)
        }
        for (let i = 0; i < diffrence; i++) {
          tempBraintrust.push(YOUTUBE_DATA[i])
        }
        returnSessions = tempBraintrust
      }
    }
    return returnSessions.sort((a, b) => a.duration - b.duration);
  };

  static removeBlackBoarder = (url: string) => {
    /*
    Youtube offers:
    http://img.youtube.com/vi/<insert-youtube-video-id-here>/mqdefault.jpg
    http://img.youtube.com/vi/<insert-youtube-video-id-here>/maxresdefault.jpg
     */
    const urlSplit = url.split('/');
    const end = urlSplit[urlSplit.length - 1];
    const endSplit = end.split('.');
    const ext = endSplit[endSplit.length - 1];

    let thumbnail = '';
    for (let i = 0; i < urlSplit.length - 1; i++) {
      thumbnail += urlSplit[i] + '/';
    }
    thumbnail += `mqdefault.${ext}`;
    return thumbnail;
  };

  static convertBase64Uri(url: any, width: number, height: number, cb: any) {
    const image = new Image();
    image.setAttribute('crossOrigin', 'anonymous');
    image.onload = function () {

      const canvas: any = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx: any = canvas.getContext('2d');
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      canvas.getContext('2d').drawImage(this, 0, 0);
      cb(canvas.toDataURL('image/jpeg'));
    };
    image.src = url;
  }

  static useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
      width: 0,
      height: 0,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  static isShowSafety = (session_type: string, length: number) => {
    const thresholdLength = session_type === 'ASYNC'
      ? Number(Config.ASYNC_THRESHOLD_LENGTH)
      : Number(Config.MOD_THRESHOLD_LENGTH);
    return length > thresholdLength;
  }

  static getSafetyBlurb = (value: string) => {
    switch (value.toLowerCase()) {
      case 'zen':
        return 'Your audience was completely at ease while participating in the experience. This enables them to immerse themselves.';
      case 'very safe':
        return 'Your audience was comfortable in your experience. This allows them to easily absorb information.';
      case 'safe':
        return 'Your audience was safe! Perhaps you can do better if your goal is to keep psychological safety high. Check the data to see where they felt unsafe to see if you can improve that part of the experience.';
      case 'unsafe':
        return 'Your audience was not feeling safe for most of your experience. This may inhibit immersion in the experience and may lead to people tuning out.';
      case 'very unsafe':
        return 'Uh oh! Your audience was very low on psychological safety. See what content may have led to this early on as this may have set the tone for the entire experience.';
    }
  }

  static getImmersionBlurb = (value: string) => {
    switch (value.toLowerCase()) {
      case 'captivated':
        return 'Your audience was truly captivated by the content you showed them. They are likely to remember and act on what they saw.';
      case 'absorbed':
        return 'Your audience emotionally connected with the content you showed them. They are likely to remember and act on what they saw. Check if there were low points that, if addressed, could make it a truly captivating experience.';
      case 'interested':
        return 'Your audience was interested by the content you showed them. Look at which moments performed best to see which are most likely to be remembered and acted on.';
      case 'indifferent':
        return 'Immersion was low for your audience. Look to see if there were long periods of low immersion (in red) that could point to problematic content areas.';
      case 'tuned out':
        return 'Immersion was very low for your audience. This might not be the right audience for your content or vice versa. By tagging participants with different traits, you can see if certain segments of your audience responded well.';
    }
  };


  static getIColor = (color: string) => {
    switch (color && color.toLowerCase()) {
      case 'green':
        return '#1DB859';
      case 'gray':
        return '#697683';
      case 'red':
        return '#ED564A';
      default:
        return '#1DB859';
    }
  };

  static emailValidate = (email: string) => {
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return validEmail.test(email);
  };

  static getClipsRequest = (selectedClips: any[]) => {
    const grouped_clips = _.mapObject(
      _.groupBy(selectedClips, 'session_code'),
      clist => clist.map(clip => _.omit(clip, 'session_code'))
    );
    const clips_session_codes = Object.keys(grouped_clips);
    const clips = [];
    for (let i = 0; i < clips_session_codes.length; i++) {
      const session_code = clips_session_codes[i];
      const clip_ids = grouped_clips[session_code].map((c: any) => c.clip_id);
      clips.push({ session_code, clip_ids })
    }

    return clips;
  };

  static compareSortLabel = (label: string) => {
    switch (label) {
      case 'tuned out':
        return 'tuned-out';
      case 'very safe':
        return 'very-safe';
      case 'very unsafe':
        return 'very-unsaf';
      default:
        return label;
    }
  };

  static dashInt = (value: any) => {
    if (value && value > 0) {
      return value
    } else {
      return 0
    }
  }

  static compareText = (value: any) => {
    switch (value) {
      case 'Very-safe':
        return 'Very Safe';
      case 'Tuned-out':
        return 'Tuned Out';
      case 'Very-safe':
        return 'Very Safe';
      case 'Very-unsafe':
        return 'Very Unsafe';
      default:
        return value
    }
  }

  static compareText2 = (value: any) => {
    switch (value) {
      case 'absorbed':
        return 'Absorbed';
      case 'captivated':
        return 'Captivated';
      case 'indifferent':
        return 'Indifferent';
      case 'interested':
        return 'Interested';
      case 'tuned-out':
      case 'tuned out':
        return 'Tuned Out';
      case 'safe':
        return 'Safe';
      case 'unsafe':
        return 'Unsafe';
      case 'very-safe':
      case 'very safe':
        return 'Very Safe';
      case 'very-unsafe':
      case 'very unsafe':
        return 'Very Unsafe';
      case 'zen':
        return 'Zen';
      default:
        return value
    }
  }

  static getTagCompare = (data: any, type: string) => {
    if(type === 'immersion'){
      const immersion: any = data.tag_wise_immersion.reduce(function (filtered: any, item: any) {
        const convertValue = item.overall_index === '-' ? 0 : item.overall_index;
        filtered[UtilService.compareText2(item.tag_name?.toLowerCase())] = convertValue;
        return filtered;
      }, {});
      return immersion
    }else {
      const safety: any = data.tag_wise_safety.reduce(function (filtered: any, item: any) {
        const convertValue = item.safety_index === '-' ? 0 : item.safety_index;
        filtered[UtilService.compareText2(item.tag_name?.toLowerCase())] = convertValue;
        return filtered;
      }, {});
      return safety
    }
  }

}

export default UtilService
